module.exports = __webpack_public_path__ + "assets/888e08cb7908e4f68ba34a5216a02c59.mp3";